import { IPatientListDto } from 'src/services/api/api-client';

export enum ReportScopeEnum {
  Study,
  Patient,
}

export type ReportExportingOptions =
  | {
      scope: ReportScopeEnum.Patient;
      patient: IPatientListDto;
    }
  | {
      scope: ReportScopeEnum.Study;
      patient?: never;
    };

export const StudyReportVariants = ['Auditlog', 'Statistics'] as const;
export type StudyReportVariantsType = (typeof StudyReportVariants)[number];

export const PatientReportVariants = ['Auditlog', 'Statistics', 'eCRF'] as const;
export type PatientReportVariantsType = (typeof PatientReportVariants)[number];

export const FileTypeVariants = ['Csv', 'Pdf'] as const;
export type FileTypeVariantsType = (typeof FileTypeVariants)[number];

export type ReportExportingFormType = {
  reportVariant: StudyReportVariantsType | PatientReportVariantsType | undefined;
  fileType: FileTypeVariantsType | undefined;
  surveyTypes: string[];
  formTypes: string[];
  noteTypes: string[];
  includeAllVersions: boolean;
  withMissedSurveys: boolean;
  signedPdf: boolean;
};
